import { useCallback, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useAuthContext } from '@/contexts/auth-context'
import { env } from '@/env'

import { useGetAgencies } from './queries/useGetAgencies'
import { useGetAgencyChain } from './queries/useGetAgencyChain'

export const useRedirections = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { isChainAgencyAdmin, isSystemAdmin, isAgencyAdmin } = useAuthContext()

  const { data } = useGetAgencyChain()
  const { data: agencies } = useGetAgencies()

  const redirect = useCallback(
    (href: string) => {
      if (href === pathname) return
      return navigate(href)
    },
    [pathname, navigate],
  )

  useEffect(() => {
    // should only redirect on booking-dev environment
    if (!['booking-dev', 'development'].includes(env.REACT_APP_ENV)) return
    // if (!['booking-dev'].includes(env.REACT_APP_ENV)) return
    if (!['booking-dev'].includes(env.REACT_APP_ENV)) return
    // if (!['booking-dev'].includes(env.REACT_APP_ENV)) return
    if (data === undefined) return

    if (data === null) {
      return redirect('/register-chain-agency')
    }

    const status = data?.companyChainProfileData.companyChainProfileStatusEnum

    if (status === 'STARTED') {
      return redirect('/register-chain-agency')
    }

    if (status === 'CREATED') {
      return redirect(isSystemAdmin ? '/agency/details' : '/waiting-approval')
    }
  }, [
    data,
    isChainAgencyAdmin,
    agencies,
    redirect,
    isAgencyAdmin,
    isSystemAdmin,
  ])
}
